import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { Project, ProjectTeaser } from 'models';
import { ProjectHelpers } from 'helpers/ProjectHelpers';

import { useTeam } from 'hooks/use-team';
import { useUser } from 'hooks/use-user';
import { DateService } from 'services/DateService';

const useProjectMeta = (project: Project | ProjectTeaser) => {
    const { updatedBy, createdBy, updatedAt, createdAt, team: teamId } = project;

    const { team, isLoading: isTeamLoading } = useTeam(teamId || undefined);

    const combinedSlug = 'combinedSlug' in project ? project.combinedSlug : project.id;
    const projectUrl = ProjectHelpers.urls.editor(combinedSlug);

    const updatedById = CollectionHelpers.id(updatedBy || createdBy || undefined);
    const { user: updatedByUser, isLoading: isUpdatedByLoading } = useUser(updatedById!);

    const createdAtLabel = createdAt ? DateService.formatDistanceToNow(createdAt) : null;
    const updatedAtLabel = updatedAt ? DateService.formatDistanceToNow(updatedAt) : null;
    const updatedWhen = updatedAtLabel || createdAtLabel;

    return {
        projectUrl,
        updatedBy: updatedById ? (updatedByUser?.name ?? updatedByUser?.email) : '',
        updatedById: updatedById ?? undefined,
        updatedWhen,
        teamName: team?.name,
        isTeamLoading,
        isUpdatedByLoading,
        updatedAt: updatedAt ? DateService.format(updatedAt, 'MMM D, HH:mm') : null,
    };
};

export { useProjectMeta };
